export default __webpack_public_path__ + "static/TheallureofFrancesMayesItaly-7112d96b6bb94f3ae1bb07b20363e231.jpg";